import React from 'react';
import { Box, Drawer, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { navigationList, NavListKey } from '@/core/lists';
import palette from '@/theme/palette.ts';

import { styles } from './styles.ts';

export const NavigationBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const navigationKeys: NavListKey[] = Object.keys(navigationList) as NavListKey[];

  const getIsButtonActive = (route: string) => {
    return location.pathname.includes(route);
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        '& .MuiDrawer-paper': {
          ...styles.drawer,
        },
      }}
    >
      {navigationKeys.map((item: NavListKey) => (
        <Box key={item}>
          <Typography variant="body2" sx={styles.listHeader}>
            {t(navigationList[item].title)}
          </Typography>
          <List>
            {navigationList[item].items.map((subItem) => (
              <ListItem
                key={subItem.label}
                onClick={() => navigate(subItem.route)}
                sx={{
                  ...styles.listItem,
                  borderLeft: getIsButtonActive(subItem.route)
                    ? `3px solid ${palette.primary.main}`
                    : 'none',
                  background: getIsButtonActive(subItem.route) ? palette.surface.lighter : 'none',
                  cursor: 'pointer',
                  transition: 'all 0.1s ease-in-out',
                }}
              >
                <ListItemText
                  primary={t(subItem.label)}
                  sx={{
                    width: '100%',
                    '& span': {
                      typography: 'body1',
                      color: getIsButtonActive(subItem.route) ? 'primary.main' : 'text.primary',
                      fontWeight: getIsButtonActive(subItem.route) ? 'bold' : 'normal',
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      ))}
    </Drawer>
  );
};
